import ContentLandingBanner from './component'
export default ContentLandingBanner
